<template>
  <b-overlay :show="category === null" rounded="sm">
    <div v-if="category !== null">
      <!-- Table Container Card -->
      <b-card class="mb-0">
        <div class="m-2">
          <b-row>
            <b-form @submit.prevent>
              <b-row>
                <b-col cols="12">
                  <b-form-group
                    label="نام دسته بندی"
                    label-for="title"
                    label-cols-md="3"
                  >
                    <b-form-input
                      v-model="category.title"
                      id="title"
                      placeholder="نام دسته بندی"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    label="توضیحات دسته بندی"
                    label-for="description"
                    label-cols-md="3"
                  >
                    <b-form-input
                      v-model="category.description"
                      id="description"
                      type="text"
                      placeholder="توضیحات دسته بندی"
                    />
                  </b-form-group>
                  <b-button
                    class="btn-primary"
                    variant="primary"
                    @click="updatePhysicalCategory"
                    >ثبت</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
          </b-row>
          <hr />
          <div class="d-flex align-items-center justify-content-between my-3">
            <h3>زیر دسته های {{ category.title }}</h3>
            <b-button
              class="btn-primary ml-1"
              variant="primary"
              v-b-modal.modal-add
            >
              اضافه کردن زیر دسته بندی
            </b-button>
          </div>
          <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="properties"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
          >
            <!-- Column: delete -->

            <template #cell(edit)="data">
              <div
                class="cursor-pointer d-flex flex-row"
                v-b-modal.modal-edit
                @click="showModal(data.item)"
              >
                <feather-icon size="20" icon="EditIcon" class="text-primary" />
              </div>
            </template>
          </b-table>
        </div>
      </b-card>
    </div>
    <!-- Edit Category Modal -->
    <b-modal
      id="modal-edit"
      centered
      :title="modalTitle"
      ok-title="ویرایش"
      cancelTitle="انصراف"
      @ok="editCategoryProperty"
    >
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12">
            <b-form-group
              v-if="editItem"
              label="نام دسته بندی"
              label-for="title"
              label-cols-md="3"
            >
              <b-form-input
                v-model="editItem.title"
                id="title"
                placeholder="نام دسته بندی"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <!-- Add Property Modal -->
    <b-modal
      id="modal-add"
      centered
      title="ساخت زیر دسته بندی جدید"
      ok-title="ثبت"
      cancelTitle="انصراف"
      @ok="addPhysicalCategoryProperty"
    >
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="نام دسته بندی"
              label-for="title"
              label-cols-md="3"
            >
              <b-form-input
                v-model="newCategoryPropertyName"
                id="title"
                placeholder="نام دسته بندی"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTable,
  BModal,
} from "bootstrap-vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent";
import PhysicalCategoryGet from "@/libs/Api/Categories/PhysicalCategories/GetASinglePhysicalCat";
import GetAPhysicalCategoryProperties from "@/libs/Api/Categories/PhysicalCategories/GetPhysicalCatProperties";
import UpdateAPhysicalCategoryProperty from "@/libs/Api/Categories/PhysicalCategories/UpdateAPhysicalCategoryProperty";
import UpdatePhysicalCategory from "@/libs/Api/Categories/PhysicalCategories/UpdateAPhysicalCategory";
import CreateAPhysicalCategoryProperty from "@/libs/Api/Categories/PhysicalCategories/CreateAPhysicalCategoryProperty";

// import BlogCategoryDeleteRequest from "@/libs/Api/Blog/BlogCategoryDeleteRequest";

export default {
  name: "physical-cat-edit",
  title: "ویرایش دسته بندی فیزیکی - پنل ادمین فرادیدار",
  data() {
    return {
      category: null,
      properties: null,
      myTableColumns: [
        { key: "physicalCategoryPropertyId", label: "شناسه" },
        { key: "title", label: "نام" },
        { key: "edit", label: "ویرایش" },
      ],
      editItem: null,
      newCategoryPropertyName: null,
    };
  },
  async created() {
    await this.getASinglePhysicalCategory();
    await this.getAPhysicalCategoryProperties();
  },
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BTable,
    BModal,
  },
  methods: {
    async addPhysicalCategoryProperty() {
      let _this = this;

      let createAPhysicalCategoryProperty = new CreateAPhysicalCategoryProperty(
        _this
      );
      createAPhysicalCategoryProperty.setParams({
        title: _this.newCategoryPropertyName,
        physicalCategoryId: _this.$route.params.id,
      });
      await createAPhysicalCategoryProperty.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `زیر دسته بندی با موفقیت ساخته شد.`,
            },
          });
          _this.getAPhysicalCategoryProperties();
        },
        function (content) {
          console.log(content);
        }
      );
    },
    async updatePhysicalCategory() {
      let _this = this;

      let updatePhysicalCategory = new UpdatePhysicalCategory(_this);
      updatePhysicalCategory.setParams(_this.category);
      await updatePhysicalCategory.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `ویرایش با موفقیت انجام شد.`,
            },
          });
          _this.getASinglePhysicalCategory();
        },
        function (content) {
          console.log(content);
        }
      );
    },
    async editCategoryProperty() {
      let _this = this;

      let updateAPhysicalCategoryProperty = new UpdateAPhysicalCategoryProperty(
        _this
      );
      updateAPhysicalCategoryProperty.setParams(_this.editItem);
      await updateAPhysicalCategoryProperty.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `ویرایش با موفقیت انجام شد.`,
            },
          });
          _this.getAPhysicalCategoryProperties();
        },
        function (content) {
          console.log(content);
        }
      );
    },
    async getASinglePhysicalCategory() {
      let _this = this;

      let physicalCategoryGet = new PhysicalCategoryGet(_this);
      physicalCategoryGet.setId(_this.$route.params.id);
      await physicalCategoryGet.fetch(
        function (content) {
          _this.category = content;
        },
        function (content) {
          console.log(content);
        }
      );
    },
    async getAPhysicalCategoryProperties() {
      let _this = this;

      let getAPhysicalCategoryProperties = new GetAPhysicalCategoryProperties(
        _this
      );
      getAPhysicalCategoryProperties.setId(_this.$route.params.id);
      await getAPhysicalCategoryProperties.fetch(
        function (content) {
          _this.properties = content;
        },
        function (content) {
          console.log(content);
        }
      );

      GetAPhysicalCategoryProperties;
    },
    async createPhysicalCategory() {
      let _this = this;

      let physicalCategoriesCreate = new PhysicalCategoriesCreate(_this);
      physicalCategoriesCreate.setParams(_this.defaultCreateData);
      await physicalCategoriesCreate.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `دسته بندی جدید اضافه شد.`,
            },
          });
          _this.getPhysicalCategories();
        },
        function (error) {
          console.log(error);
        }
      );
    },
    async deleteCategory(param) {
      let _this = this;

      let physicalCategoryDelete = new PhysicalCategoryDelete(_this);
      physicalCategoryDelete.setId(param);
      await physicalCategoryDelete.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `دسته بندی جدید حذف شد.`,
            },
          });
          _this.getPhysicalCategories();
        },
        function (error) {
          console.log(error);
        }
      );
    },
    showModal(item) {
      this.editItem = item;
    },
  },
  computed: {
    categoryTitle: {
      get() {
        return this.defaultCreateData.title;
      },
      set(newValue) {
        this.defaultCreateData.title = newValue;
        this.defaultCreateData.seoTitle = newValue;
      },
    },
    categoryDescription: {
      get() {
        return this.defaultCreateData.description;
      },
      set(newValue) {
        this.defaultCreateData.description = newValue;
        this.defaultCreateData.seoDescription = newValue;
      },
    },
    modalTitle() {
      if (this.editItem) {
        return `ویرایش ${this.editItem.title}`;
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped></style>
